module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "y-btn",
    class: [_vm.style, _vm.clicked ? 'y-btn-clicked' : null],
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.click
    }
  }, [(_vm.loading) ? _c('y-svg', {
    attrs: {
      "width": 14,
      "color": "#fff",
      "type": "loading"
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-cb4fe812!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./components/components/button/button.vue
// module id = 499
// module chunks = 27